"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var theme_ui_1 = require("theme-ui");
var styled_1 = __importDefault(require("@emotion/styled"));
var core_1 = require("@emotion/core");
var spinningAnimation = core_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n"], ["\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n"])));
var dynamicBefore = function (props) {
    if (props.isLoading) {
        return theme_ui_1.css({
            "::before": {
                content: '""',
                position: "absolute",
                right: "0.625rem",
                top: "50%",
                boxSizing: "border-box",
                mt: "-0.75rem",
                width: "1.5rem",
                height: "1.5rem",
                border: "0.1875rem solid #071820",
                borderLeftColor: "transparent",
                borderRightColor: "transparent",
                borderRadius: "50%",
                opacity: 0.4,
                animation: spinningAnimation.toString() + " 0.8s linear infinite"
            }
        });
    }
    return '';
};
exports.ExtendedButtonUI = styled_1.default(theme_ui_1.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), dynamicBefore);
var templateObject_1, templateObject_2;
